import { DomElementAlignment, DomTargetPosition, IconButton, OdinIconSize, Tooltip } from '@myosh/odin-components';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { selectSidePanelFullScreen, setSidePanelFullScreen } from '../../redux/slices/side-panel-slice';
import SidePanelItem from './side-panel-item.component';

export default function SidePanelContent() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const fullScreen = useAppSelector(selectSidePanelFullScreen);

  const toggleFullScreen = () => {
    const newFullScreen = !fullScreen;
    dispatch(setSidePanelFullScreen(newFullScreen));
  };

  const panelStyles = 'flex flex-col h-full bg-gray-5';

  return (
    <div className={panelStyles}>
      <Tooltip
        description={fullScreen ? t('fullscreen-exit', 'Exit Full Screen') : t('fullscreen', 'Full Screen')}
        tooltipClassName="bg-mono-1"
        wrapperClassName="absolute h-6 w-6 max-sm:hidden"
        debounceTime={200}
        tooltipAlignment={DomElementAlignment.TopLeft}
        tooltipTargetPosition={DomTargetPosition.BottomRight}
      >
        <IconButton
          classNames="absolute p-1 bg-gray-4 rounded-br-lg max-sm:hidden"
          onClick={toggleFullScreen}
          icon={fullScreen ? 'Minimize' : 'Maximize'}
          iconSize={OdinIconSize.ExtraSmall}
        />
      </Tooltip>
      <div className="flex flex-col h-full overflow-y-auto p-5 sm:px-8 pb-0">
        <SidePanelItem />
      </div>
    </div>
  );
}
